module.exports = __webpack_public_path__ + "img/boots.a0aaf178.png";